import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import { formatDate } from '@angular/common';
import { getISOWeek } from 'date-fns';
import { DatePipe } from '@angular/common';

export class CustomDateFormatter extends CalendarDateFormatter {

    public monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
        return formatDate(date, 'EEE', locale);
    }

    // public monthViewTitle({ date, locale }: DateFormatterParams): string {
    //     return formatDate(date, 'MMM y', locale);
    // }

    public weekViewColumnHeader({ date, locale }: DateFormatterParams): string {
        return formatDate(date, 'EEE', locale);
    }

    // public dayViewHour({ date, locale }: DateFormatterParams): string {
    //     return formatDate(date, 'HH:mm', locale);
    // }

}
